import React, { Component } from "react";

import { connect } from "react-redux";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class RoleList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // components: [],
      loading: true
    };
    this.insertRole = this.insertRole.bind(this);
    this.deleteRole = this.deleteRole.bind(this);
  }

  getRoleList = () => {
    axios
      .get(`${URL.api}configuration/role/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState(
            () => ({
              roles: resp.data.data
            }),
            () => {
              this.setState(() => ({
                loading: false
              }));
            }
          );
        },
        error => {
          this.props.logout(this.props.user.token);
        }
      );
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.getRoleList();
  }

  insertRole = () => {
    this.props.history.push("/role/create");
  };

  deleteRole = data => {
    this.setState(
      () => ({
        loading: true
      }),
      () => {
        data.forEach(elem => {
          let dataSend = {
            id: elem,
            loggedUser: this.props.user.user.id
          };
          axios
            .post(`${URL.api}role/delete`, dataSend, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(resp => {
              if (resp.data.success) {
                this.getRoleList();
              }
            });
        });
      }
    );
  };

  render() {
    return (
      <div id="list" className="animated fadeIn">
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            <Breadcrumb current={this.props.currentRoute} />
            {this.state.roles ? (
              <DataTable
                list={this.state.roles}
                path="/role/edit/"
                title="Roles table"
                header={[
                  { name: "id", denomination: "id" },
                  { name: "name", denomination: "name" },
                  { name: "type", denomination: "type" },
                  { name: "group_id", denomination: "group_id" }
                ]}
                csv
                insert
                delete
                insertAction={this.insertRole}
                deleteAction={this.deleteRole}
              />
            ) : (
              "Loading..."
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RoleList);
